import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faOilTemperature,
  faScrewdriverWrench,
  faLaptop,
  faArrowFromLeft,
  faArrowFromRight,
  faPlus,
  faMinus,
  faCircle,
  faArrowUp,
  faArrowDown,
  faSpinnerThird,
  faTint,
  faUser,
  faRuler,
  faLink,
  faTrash,
  faSearch,
  faPencil,
  faClone,
  faAngleUp,
  faAngleDown,
  faTimes,
  faCheckCircle,
  faTimesCircle,
  faUndo,
  faBan,
  faCog,
  faCloudUploadAlt,
  faFileImport,
  faEye,
  faPlusCircle,
  faMinusCircle,
  faHouseUser,
  faCalendar,
  faChevronRight,
  faExpandArrows,
  faCompress,
  faCloudDownloadAlt,
  faMoon,
  faChartLine,
  faGears,
  faComment,
  faRug,
} from "@fortawesome/pro-regular-svg-icons";

import {
  faCircle as fasCircle,
  faDroplet as fasDroplet,
  faUser as fasUser,
  faRuler as fasRuler,
  faInfoCircle as fasInfoCircle,
  faChartLine as fasChartLine,
  faExclamationCircle as fasExclamationCircle,
  faFileCheck as fasFileCheck,
  faPlusCircle as fasPlusCircle,
  faMinusCircle as fasMinusCircle,
  faCalculator as fasCalculator,
  faExclamationTriangle as fasExclamationTriangle,
  faSun as fasSun,
  faPrint as fasPrint,
  faOilWell as fasOilWell,
  faEngine as fasEngine,
  faSparkles as fasSparkles,
  faEllipsisV as fasEllipsisV,
  faClone as fasClone,
  faFileChartLine as fasFileChartLine,
  faTrash as fasTrash,
  faClipboard as fasClipboard,
  faArrowDownToLine as fasArrowDownToLine,
  faPencilRuler as fasPencilRuler,
  faCalendar as fasCalendar,
  faHeartbeat as fasHeartbeat,
  faInfo as fasInfo,
  faFileInvoiceDollar,
  faLinesLeaning as fasLinesLeaning,
  faSquareX as fasSquareX,
  faSquareCheck as fasSquareCheck,
  faHorizontalRule as fasHorizontalRule,
  faCaretUp as fasCaretUp,
  faCaretDown as fasCaretDown,
  faRug as fasRug,
  faTriangle as fasTriangle,
  faBullseye as fasBullseye,
  faTriangleExclamation as fasTriangleExclamation,
  faCircleExclamation as fasCircleExclamation,
  faPump as fasPump,
  faBolt as fasBolt,
  faFilter as fasFilter,
  faPlug as fasPlug,
  faShieldHalved as fasShieldHalved,
  faGauge as fasGauge,
  faSliders as fasSliders,
  faServer as fasServer,
  faTransformerBolt as fasTransformerBolt,
} from "@fortawesome/pro-solid-svg-icons";

library.add(
  fasEngine,
  faOilTemperature,
  fasOilWell,
  faScrewdriverWrench,
  faLaptop,
  faArrowFromLeft,
  faArrowFromRight,
  faChartLine,
  fasPrint,
  faPlus,
  faMinus,
  faCircle,
  fasCircle,
  faSpinnerThird,
  faTint,
  fasDroplet,
  faUser,
  fasUser,
  faRuler,
  fasRuler,
  faLink,
  faTrash,
  faSearch,
  faPencil,
  faClone,
  faAngleUp,
  faAngleDown,
  faArrowUp,
  faArrowDown,
  faTimes,
  faCheckCircle,
  fasInfoCircle,
  faTimesCircle,
  faPlusCircle,
  fasPlusCircle,
  faUndo,
  faBan,
  faCog,
  fasChartLine,
  faCloudUploadAlt,
  faCloudDownloadAlt,
  faFileImport,
  faEye,
  fasExclamationCircle,
  fasFileCheck,
  faHouseUser,
  faCalendar,
  faChevronRight,
  fasCalculator,
  faExpandArrows,
  faCompress,
  faMinusCircle,
  fasMinusCircle,
  fasExclamationTriangle,
  faMoon,
  fasSun,
  fasSparkles,
  fasEllipsisV,
  fasFileChartLine,
  fasClone,
  fasTrash,
  fasClipboard,
  fasArrowDownToLine,
  fasPencilRuler,
  fasCalendar,
  fasHeartbeat,
  fasInfo,
  faGears,
  fasLinesLeaning,
  faComment,
  fasSquareX,
  fasSquareCheck,
  fasHorizontalRule,
  fasCaretUp,
  fasCaretDown,
  faFileInvoiceDollar,
  faRug,
  fasRug,
  fasTriangle,
  fasBullseye,
  fasTriangleExclamation,
  fasCircleExclamation,
  fasPump,
  fasBolt,
  fasFilter,
  fasPlug,
  fasShieldHalved,
  fasGauge,
  fasSliders,
  fasServer,
  fasTransformerBolt,
);
dom.watch();

export { FontAwesomeIcon };
